module.exports = __webpack_public_path__ + "static/media/send.8ae12162.svg";